export default __webpack_public_path__ + "static/media/data-insights-analytics.f8db565b.jpeg";